import { render, staticRenderFns } from "./OfferEdit.vue?vue&type=template&id=4c785dd4&scoped=true"
import script from "./OfferEdit.vue?vue&type=script&lang=js"
export * from "./OfferEdit.vue?vue&type=script&lang=js"
import style0 from "./OfferEdit.vue?vue&type=style&index=0&id=4c785dd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c785dd4",
  null
  
)

export default component.exports